import React, { Component } from 'react';
import { Button, Col, Row,   FormGroup, FormControl, } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import Footer from '../../../../components/widgets/Footer';
import logo from '../../../../images/inflo_logo.png';
import apple from '../../../../images/apple.png';
import facebook from '../../../../images/facebook.png';
import googleplus from '../../../../images/googleplus.png';
import RegisterWithEmailInfloPage from './RegisterWithEmailInflo';
import LoginInfloPage from '../login/LoginInfloPage';
import { auth } from '../../../../firebase';
import firebase from 'firebase/compat/app';
import { default as config, CONSTANTS } from '../../../../constants/constants';
import axios from 'axios';
import 'sweetalert2/src/sweetalert2.scss';
import swal from 'sweetalert2';
import { withRouter } from 'react-router-dom';
import Logo from '../../../../components/widgets/Logo';
import MobileFooter from '../../../../components/widgets/MobileFooter';
import { BrowserView, MobileView } from 'react-device-detect';
import logoFooter from '../../../../images/logo_footer_inflo.png';
import InfloWelcome from '../InfloWelcome';
import { Helmet } from 'react-helmet';
import VisitorMessagePanel from '../../../visitorMessagePanel/components/visitorMessagePanel';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

class RegisterInfloForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      component: 'registerInflo',
      userEmail: '',
    };
  }

  redirectToRegisterWithEmailInflo = () => {
    this.setState({ component: 'registerWithEmailInflo' });
  };

  redirectToLoginInflo = () => {
    this.setState({ component: 'loginInflo' });
  };

  redirectToInfloWelcome = () => {
    this.setState({ component: 'infloWelcome' });
  };

  googleSignIn = () => {
    // this.setState(byPropKey('loading', true));
    let currentUser;
    const $this = this;

    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        auth
          .doSignInAndRetrieveDataWithCredential(result.credential)
          .then(() => {
            currentUser = firebase.auth().currentUser;
            $this.setState(byPropKey('loading', false));
            if (currentUser) {
              return currentUser.getIdToken();
            } else {
              return Promise.reject({ message: 'User not found' });
            }
          })
          .then(() => {
            $this.redirectToLoginInflo();
          })
          .catch(function(error) {
            $this.setState(byPropKey('error', error));
            $this.setState(byPropKey('loading', false));
            swal({
              imageUrl: CONSTANTS.swalLogo,
              title: '<div class="titleModal">We\'re sorry there was an error.</div>',
              html: `<p class="contentModal">${error.message}</p>`,
              showConfirmButton: false,
              showCloseButton: true,
              background: '#121C24',
              allowOutsideClick: false
            });
          });
      })
      .catch(function(error) {
        swal({
          imageUrl: CONSTANTS.swalLogo,
          title: '<div class="titleModal">We\'re sorry there was an error</div>',
          html: `<p class="contentModal">${error.message}</p>`,
          showConfirmButton: false,
          showCloseButton: true,
          background: '#121C24',
          allowOutsideClick: false
        }).catch(swal.noop);
      });
  };

  facebookSignIn = () => {
    let currentUser;
    let token;
    const $this = this;

    var provider = new firebase.auth.FacebookAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        auth
          .doSignInAndRetrieveDataWithCredential(result.credential)
          .then(() => {
            currentUser = firebase.auth().currentUser;
            if (currentUser) {
              return currentUser.getIdToken();
            } else {
              return Promise.reject({ message: 'User not found' });
            }
          })
          .then((_token) => {
            token = _token;
            const options = {
              method: 'POST',
              headers: { 'X-Firebase-Auth': token },
              url: `${config.serverURL}/auth/user`
            };
            return axios(options);
          })
          .catch(function(error) {
            $this.setState(byPropKey('error', error));
            swal({
              imageUrl: CONSTANTS.swalLogo,
              title: '<div class="titleModal">We\'re sorry there was an error</div>',
              html: `<p class="contentModal">${error.message}</p>`,
              showConfirmButton: false,
              showCloseButton: true,
              background: '#121C24',
              allowOutsideClick: false
            });
          });
      });
  };

  appleSignIn = () => {
    //this.setState(byPropKey('loading', true));
    let currentUser;
    const $this = this;
    var provider = new firebase.auth.OAuthProvider('apple.com');
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        auth
          .doSignInAndRetrieveDataWithCredential(result.credential)
          .then(() => {
            currentUser = firebase.auth().currentUser;
            $this.setState(byPropKey('loading', false));
            if (currentUser) {
              return currentUser.getIdToken();
            } else {
              return Promise.reject({ message: 'User not found' });
            }
          })
          .then(() => {
            $this.redirectToLoginInflo();
          })
          .catch(function(error) {
            $this.setState(byPropKey('error', error));
            $this.setState(byPropKey('loading', false));
            swal({
              imageUrl: CONSTANTS.swalLogo,
              title: '<div class="titleModal">We\'re sorry there was an error</div>',
              html: `<p class="contentModal">${error.message}</p>`,
              showConfirmButton: false,
              showCloseButton: true,
              background: '#121C24',
              allowOutsideClick: false
            });
          });
      })
      .catch(function(error) {
        swal({
          imageUrl: CONSTANTS.swalLogo,
          title: '<div class="titleModal">We\'re sorry, there was an error</div>',
          html: `<p class="contentModal">${error.message}</p>`,
          showConfirmButton: false,
          showCloseButton: true,
          background: '#121C24',
          allowOutsideClick: false
        }).catch(swal.noop);
      });
  };

  renderRegistrationPanel = (showCopyright = false) => {
    const { email, password, forgotPassword, loading } = this.state;

    const isInvalid =
      password === '' || email === '' || this.state.disabled === true;

    const isInvalid2 =
      forgotPassword === null ||
      forgotPassword === undefined ||
      forgotPassword === '';

    let enterEmail;

    enterEmail = () => {
      debugger;
      if (document.getElementById('forgotPassword')) {
        if (
          document.getElementById('forgotPassword').style.display === 'none'
        ) {
          document.getElementById('forgotPassword').style.display = 'block';

          var heightForm = document.getElementsByClassName('loginInfloForm')[0]
            .offsetHeight;
          var heightWindow = window.innerHeight;
          var widthWindow = window.innerWidth;

          if (heightWindow < heightForm) {
            if (widthWindow > 991) {
              document.getElementsByClassName(
                'loginInfloForm'
              )[0].style.maxHeight = heightWindow - 80 + 'px';
            } else {
              document.getElementsByClassName(
                'loginInfloForm'
              )[0].style.maxHeight = heightWindow - 30 + 'px';
            }
          }
        } else {
          document.getElementById('forgotPassword').style.display = 'none';
        }
      }
    };

    return (
      <>
        {/* <div className="textLogoInflo">Sign in to Inflo</div> */}
        <form className="loginForm signinForm24" onSubmit={this.onSubmit}>
          <div style={{fontSize: 20, fontWeight: 400, marginTop: 18}}>Create Your Account</div>
        <div className="form-group">
            <Button
              onClick={this.appleSignIn}
              className="buttonApple apple-btn button-oval button-signin24"
              style={{marginTop: 24}}
            >
              <img src={apple} height={20} width={20} alt="apple" style={{marginRight: 6, verticalAlign: 'text-bottom'}}  />
              Continue with Apple ID
            </Button>
        <div className="form-group">
            <Button
              bsStyle="default"
              onClick={this.googleSignIn}
              className="google-btn button-oval button-signin24"
            >
              <img src={googleplus} height={20} width={20} alt="google" style={{marginRight: 4, verticalAlign: 'bottom'}} />{' '}
              Continue with Google
            </Button>
          </div>

          </div>
          <div class="c-horizontal_content_rule" style={{width: '70%', margin: 'auto', marginTop: 24, marginBottom: 24}}>
            <hr class="c-horizontal_content_rule__leftrule divider24" />
              <div class="c-horizontal_content_rule__content">or</div>
              <hr class="c-horizontal_content_rule__rightrule divider24" />
          </div>
          <div className="form-group">
            <button
              class="login-btn button-oval button-signin24 button-brand24 inflo24-gradient "
              type="submit"
              disabled={false}
              onClick={this.redirectToRegisterWithEmailInflo}
              >
              Continue With Email
            </button>
          </div>
          <div className="other-links form-group">
            <hr className={'divider24'} />
            <div style={{fontSize: 14}}>Already have an account?</div>
            <div
              className="new-acct other-link"
              onClick={this.redirectToLoginInflo.bind(this)}
              style={{ textDecoration: 'underline', fontSize: 14, marginTop: 8}}
            >
              Sign In
            </div>

          </div>
        </form>

        {showCopyright && <MobileFooter />}
      </>
    )
  }

  render() {
    if (
      this.state.component &&
      this.state.component === 'registerInflo' &&
      this.state.component !== 'infloWelcome'
    ) {
      return (
        <React.Fragment>
          {/*<MobileView viewClassName='mv'>
                        <Helmet>
                            <style>{'body { background-color: #121C24!important; }'}</style>
                        </Helmet>
                        <Logo />
                        <div className='textLogoInflo'>Sign up<br />With Social</div>
                        <form className='loginForm'>
                            <div className='form-group'>
                                <Button bsStyle="default" onClick={this.googleSignIn} className='google-btn'>
                                    <img src={googleplus} height={25} width={25} alt="google" /> Login with Google
                                </Button>
                            </div>

                            <div className="form-group">
                                <Button onClick={this.appleSignIn} className='buttonApple apple-btn'>
                                    <img src={apple} height={25} width={25} alt="apple" /> Login with Apple
                                </Button>
                            </div>
                            <div className='signup-text form-group'>Or</div>
                            <div className="form-group">
                                <button className='btn login-inflo-button' type="submit" onClick={this.redirectToRegisterWithEmailInflo}>Email</button>
                            </div>
                            <div className="other-link form-group">
                                <div style={{textDecoration:'underline'}} className="center" onClick={this.redirectToLoginInflo}>
                                    Already have an account?
                                </div>
                            </div>
                        </form>
                        <MobileFooter />
                    </MobileView>
                    <BrowserView>*/}
          <Helmet>
            {/* <style>{'body { background-color: white!important; }'}</style> */}
          </Helmet>
          <MobileView viewClassName="mv">
            {/* <Helmet>
              <style>{'body { background-color: #121C24!important; }'}</style>
            </Helmet> */}
              <Logo />
              <Dialog
                ref={(el) => {
                  this.dialog = el;
                }}
              />
            {this.renderRegistrationPanel(true)}
          </MobileView>
          <BrowserView>
            {/* <Helmet>
              <style>{'body { background-color: white!important; }'}</style>
            </Helmet> */}
            <div>
            <div className="paddingBlockInflo login-inflo-page"
                   style={{
                     background: `url(${CONSTANTS.heroImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'top center',
                    backgroundSize: 'cover'
                  }}
                >
                <div className='browser-signin-panel'>
                <Logo />
                  <Dialog
                    ref={(el) => {
                      this.dialog = el;
                    }}
                  />
                {this.renderRegistrationPanel()}

                  </div>
                <VisitorMessagePanel />
                </div>
                <MobileFooter />
            </div>
          </BrowserView>
          <div>
            {/* <div className="paddingBlockInflo login-inflo-page">
              <Row
                className="show-grid"
                style={{ marginRight: '0', marginLeft: '0' }}
              >
                <Col xs={5} className="loginInfloForm">
                  <div className="logoInflo">
                    <img src={logo} alt="logo" />
                  </div>
                  <div className="textLogoInflo">Sign up with Social</div>
                  <div className="button-sign-in-inflo">
                    <Button
                      onClick={this.googleSignIn}
                      className="buttonGoogleInflo"
                      style={{ marginRight: '15px' }}
                    >
                      <img
                        src={googleplus}
                        height={20}
                        width={20}
                        alt="google plus"
                      />
                      <span>Google</span>
                    </Button>
                    <Button
                      onClick={this.appleSignIn}
                      className="buttonAppleInflo"
                      style={{ marginLeft: '15px' }}
                    >
                      <img src={apple} height={20} width={20} alt="apple" />
                      <span>Apple</span>
                    </Button>
                  </div>
                  <div className="textLogoInflo">Or</div>
                  <div className="signupSocial">
                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                      <button
                        className="btn login-inflo-button"
                        type="submit"
                        onClick={this.redirectToRegisterWithEmailInflo}
                      >
                        Email
                      </button>
                    </div>
                  </div>
                  <div className="row linkAccountInflo">
                    <div className="col-md-12">
                      <div
                        style={{ textDecoration: 'underline' }}
                        onClick={this.redirectToLoginInflo.bind(this)}
                      >
                        Already have an account?
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div id="linksInflo">
                      <span style={{ color: '#a1a1a1' }}>
                        © Copyright 2022 Inflo, Inc.
                      </span>{' '}
                      |{' '}
                      <a
                        className="linkpaInflo"
                        href="https://www.notecast.app/privacy/"
                      >
                        Privacy Policy
                      </a>{' '}
                      |{' '}
                      <a
                        className="linkpaInflo"
                        href="https://www.notecast.app/legal/"
                      >
                        License Agreement
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
            </div> */}
            {/* <div className="footerInflo">
              <div className="row">
                <div className="col-md-12">
                  <div className="imgFooterInflo">
                    <img
                      style={{ width: '400px' }}
                      src={logoFooter}
                      alt="logo"
                    />
                  </div>
                  <div className="textFooterInflo">
                    <span>users</span>
                  </div>
                  <div className="linkFooterInflo">
                    <div
                      style={{ textDecoration: 'underline' }}
                      onClick={this.redirectToInfloWelcome}
                    >
                      click here
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </React.Fragment>
      );
    } else if (
      this.state.component &&
      this.state.component === 'registerWithEmailInflo'
    ) {
      return (
        <RegisterWithEmailInfloPage
          history={this.props.history}
          code={this.props.match.params.code}
        />
      );
    } else if (
      this.state.component &&
      this.state.component === 'infloWelcome'
    ) {
      return <InfloWelcome />;
    } else {
      return (
        <LoginInfloPage
          history={this.props.history}
          code={this.props.match.params.code}
        />
      );
    }
  }
}

export default withRouter(RegisterInfloForm);
